import { useTranslation } from 'react-i18next'
import { Link } from 'react-router'
import { gql } from '@apollo/client'
import { useQuery } from '@apollo/client/react'

import { ChevronRightIcon } from '@pleio/icons/chevron-right'

import Accordeon from 'js/components/Accordeon'
import { Col } from 'js/components/Grid'

import styles from './Trending.module.css'

const Trending = () => {
    const { t } = useTranslation()

    const { data } = useQuery(TRENDING)
    const { trending } = data || {}

    if (!trending || trending.length === 0) {
        return null
    }

    const items = trending.map((item, i) => (
        <Link
            key={i}
            to={`/trending/${encodeURIComponent(item.tag)}`}
            className={styles.wrapper}
        >
            <span>{item.tag}</span>
            <ChevronRightIcon />
        </Link>
    ))

    return (
        <Col
            mobileLandscape={1 / 2}
            tablet={1 / 2}
            className="ActivityStreamTrending"
        >
            <Accordeon title={t('global.trending-title')}>{items}</Accordeon>
        </Col>
    )
}

const TRENDING = gql`
    query Trending {
        trending {
            tag
            likes
        }
    }
`

export default Trending
